import React from 'react';

export default ({style}) => <div className="progress-infinite" />;
